module.exports = {
  accountType: require('./accountType'),
  claimType: require('./claimType'),
  claimStatus: require('./claimStatus'),
  dictOperationReason: require('./dictOperationReason'),
  error: require('./error'),
  fraudType: require('./fraudType'),
  infractionAnalysisResult: require('./infractionAnalysisResult'),
  infractionSituationType: require('./infractionSituationType'),
  infractionStatus: require('./infractionStatus'),
  infractionType: require('./infractionType'),
  participantRole: require('./participantRole'),
  personType: require('./personType'),
  pixKeyType: require('./pixKeyType'),
  qrcodeAgentMode: require('./qrcodeAgentMode'),
  qrcodeResponseFormat: require('./qrcodeResponseFormat'),
  qrcodeStatus: require('./qrcodeStatus'),
  qrcodeValueChangeMode: require('./qrcodeValueChangeMode'),
  refundAnalysisResult: require('./refundAnalysisResult'),
  refundRejectionStatus: require('./refundRejectionStatus'),
  refundStatus: require('./refundStatus'),
  refundType: require('./refundType')
};
